import {Anchor, Text, type TextProps} from '@mantine/core'
import {type ReactNode, useState} from 'react'

const FOLD_AFTER_CHARACTERS = 400
const FOLDED_CHARACTERS = 280

type FoldedTextProps = TextProps & {
    text: string
    label?: ReactNode
}

export function FoldedText({text, label, ...textProps}: FoldedTextProps) {
    const [open, setOpen] = useState(false)
    const long = text.length > FOLD_AFTER_CHARACTERS
    const shown = long && !open ? `${text.slice(0, FOLDED_CHARACTERS).trimEnd()}…` : text

    return (
        <Text size="sm" style={{whiteSpace: 'pre-wrap'}} {...textProps}>
            {label}
            {shown}
            {long ? (
                <>
                    {' '}
                    <Anchor
                        component="button"
                        type="button"
                        size="sm"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? 'Show less' : 'Show more'}
                    </Anchor>
                </>
            ) : null}
        </Text>
    )
}
